import { render } from "./ChangeTaxiStandForm.vue?vue&type=template&id=28ed22a5"
import script from "./ChangeTaxiStandForm.vue?vue&type=script&lang=js"
export * from "./ChangeTaxiStandForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ChangeTaxiStandForm.vue?vue&type=style&index=0&id=28ed22a5&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__